//HDI Priority
export const HDI_TICKET_INCIDENT_TYPE_INCIDENT = 'INCIDENT';
export const HDI_TICKET_INCIDENT_TYPE_SERVICE_REQUEST = 'SERVICE_REQUEST';

